// extracted by mini-css-extract-plugin
export default {"main":"Mfa-z"};